import { render, staticRenderFns } from "./ClientBillingLedgerSidebar.vue?vue&type=template&id=ee28995e"
import script from "./ClientBillingLedgerSidebar.vue?vue&type=script&lang=js"
export * from "./ClientBillingLedgerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports